import { useContext, useEffect, useState } from 'react';

import styles from './QuickPresentationAddComponent.module.css'

import { ProjectDetailsContext } from "../../../contexts/projectDetailsContext";

import DetailsCardComponent from './DetailsCardComponent';
import AdministratorCardComponent from './AdministratorCardComponent'

const QuickPresentationAddComponent = () => {

    const { editConference } = useContext(ProjectDetailsContext)

    const [noLightningSpeaker, setNoLightningSpeaker] = useState(false)

    useEffect(() =>{
        let noLightning = true

        for(let i = 0; i < editConference.attachedParticipants.length; i++){
            if(editConference.attachedParticipants[i].participant.role){
                noLightning = false
                break;
            }
        }

        setNoLightningSpeaker(noLightning)
    },[editConference])

    return (
        <DetailsCardComponent title={'LIGHTNING SPEAKER'} isList={false} >
            <div className={styles.component}>
                {editConference.attachedParticipants.map((participant) => participant.participant.role === "ADMINISTRATOR" && 
                    <AdministratorCardComponent key={participant._id} user={participant.participant}></AdministratorCardComponent>
                )}
                {noLightningSpeaker && <div className={styles.explaining}>
                    There are no suitable participants added at the conference table. Please set up the sitting arrangement and then you can select lightning speakers from the participants 
                    that are adminstrators.
                </div>}
            </div>
        </DetailsCardComponent>
    )

}
export default QuickPresentationAddComponent;